export default "__VITE_ASSET__DtzsglVU__"